
    import './styles.scoped.css';
    export default {
  "card-inner": "awsui_card-inner_p8a6i_1mnbx_101",
  "root": "awsui_root_p8a6i_1mnbx_137",
  "header-variant-full-page": "awsui_header-variant-full-page_p8a6i_1mnbx_179",
  "header-refresh": "awsui_header-refresh_p8a6i_1mnbx_179",
  "list": "awsui_list_p8a6i_1mnbx_188",
  "list-grid-1": "awsui_list-grid-1_p8a6i_1mnbx_199",
  "card": "awsui_card_p8a6i_1mnbx_101",
  "list-grid-2": "awsui_list-grid-2_p8a6i_1mnbx_202",
  "list-grid-3": "awsui_list-grid-3_p8a6i_1mnbx_205",
  "list-grid-4": "awsui_list-grid-4_p8a6i_1mnbx_208",
  "list-grid-5": "awsui_list-grid-5_p8a6i_1mnbx_211",
  "list-grid-6": "awsui_list-grid-6_p8a6i_1mnbx_214",
  "list-grid-7": "awsui_list-grid-7_p8a6i_1mnbx_217",
  "list-grid-8": "awsui_list-grid-8_p8a6i_1mnbx_220",
  "list-grid-9": "awsui_list-grid-9_p8a6i_1mnbx_223",
  "list-grid-10": "awsui_list-grid-10_p8a6i_1mnbx_226",
  "list-grid-11": "awsui_list-grid-11_p8a6i_1mnbx_229",
  "list-grid-12": "awsui_list-grid-12_p8a6i_1mnbx_232",
  "list-grid-13": "awsui_list-grid-13_p8a6i_1mnbx_235",
  "list-grid-14": "awsui_list-grid-14_p8a6i_1mnbx_238",
  "list-grid-15": "awsui_list-grid-15_p8a6i_1mnbx_241",
  "list-grid-16": "awsui_list-grid-16_p8a6i_1mnbx_244",
  "list-grid-17": "awsui_list-grid-17_p8a6i_1mnbx_247",
  "list-grid-18": "awsui_list-grid-18_p8a6i_1mnbx_250",
  "list-grid-19": "awsui_list-grid-19_p8a6i_1mnbx_253",
  "list-grid-20": "awsui_list-grid-20_p8a6i_1mnbx_256",
  "selection-control": "awsui_selection-control_p8a6i_1mnbx_260",
  "loading": "awsui_loading_p8a6i_1mnbx_270",
  "empty": "awsui_empty_p8a6i_1mnbx_271",
  "has-header": "awsui_has-header_p8a6i_1mnbx_278",
  "refresh": "awsui_refresh_p8a6i_1mnbx_281",
  "card-header": "awsui_card-header_p8a6i_1mnbx_352",
  "card-header-inner": "awsui_card-header-inner_p8a6i_1mnbx_360",
  "card-selectable": "awsui_card-selectable_p8a6i_1mnbx_364",
  "card-selected": "awsui_card-selected_p8a6i_1mnbx_367",
  "section": "awsui_section_p8a6i_1mnbx_375",
  "section-header": "awsui_section-header_p8a6i_1mnbx_383",
  "section-content": "awsui_section-content_p8a6i_1mnbx_389",
  "footer-pagination": "awsui_footer-pagination_p8a6i_1mnbx_399"
};
  